import $ from 'jquery';
import { SetValueOnClick } from './set-value-on-click';
const PAGINATION_SELECTOR = '.js__ajax-pagination';
const PAGINATION_WRAPPER_SELECTOR = '.js__ajax-pagination-wrapper';
const PAGINATION_WRAPPER_LOADER_SELECTOR = '.js__pagination-wrapper-loader';
const LOADER = '<div class="ui active inverted dimmer js__pagination-wrapper-loader"><div class="ui loader"></div></div>';
export class AjaxPagination {
    static init($root = $('body')) {
        const $element = $root.find(PAGINATION_SELECTOR);
        if (!$element.length) {
            return;
        }
        this.initActions($element);
    }
    static initActions($element) {
        $element.find('.item').on('click', e => {
            e.preventDefault();
            const $element = $(e.currentTarget);
            $.ajax({
                method: 'GET',
                url: $element.attr('href'),
                beforeSend: () => {
                    $element.closest(PAGINATION_WRAPPER_SELECTOR).append(LOADER);
                },
            })
                .done(data => {
                const $content = $(data).find(PAGINATION_WRAPPER_SELECTOR);
                const $paginationWrapper = $element.closest(PAGINATION_WRAPPER_SELECTOR);
                $paginationWrapper.html($content.html().replaceAll('%buttonValue%', $paginationWrapper.data('button-value')));
                this.init($paginationWrapper);
                SetValueOnClick.init($paginationWrapper);
            })
                .fail(xhr => {
                $element.closest(PAGINATION_WRAPPER_SELECTOR).find(PAGINATION_WRAPPER_LOADER_SELECTOR).remove();
            });
        });
    }
}
